module.exports = __webpack_public_path__ + "static/media/rams-digital-media.63f02443.png";